'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Illustration = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactCssThemr = require('react-css-themr');

var _identifiers = require('../../identifiers');

var _Illustration = require('./Illustration.view');

var _Illustration2 = _interopRequireDefault(_Illustration);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // UI


var IllustrationController = function (_PureComponent) {
  _inherits(IllustrationController, _PureComponent);

  function IllustrationController() {
    _classCallCheck(this, IllustrationController);

    return _possibleConstructorReturn(this, (IllustrationController.__proto__ || Object.getPrototypeOf(IllustrationController)).apply(this, arguments));
  }

  _createClass(IllustrationController, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          color = _props.color;
      return _react2['default'].createElement(_Illustration2['default'], {
        name: name,
        primaryColor: color,
        height: this.height,
        wrapperClasses: this.wrapperClasses
      });
    }
  }, {
    key: 'wrapperClasses',
    get: function get() {
      var _props2 = this.props,
          theme = _props2.theme,
          className = _props2.className;
      return (0, _classnames2['default'])(theme.wrapper, className);
    }
  }, {
    key: 'height',
    get: function get() {
      var height = this.props.height;
      var parsedHeight = parseInt(height);
      if (isNaN(parsedHeight)) return height;
      return parsedHeight + 'px';
    }
  }]);

  return IllustrationController;
}(_react.PureComponent);

IllustrationController.propTypes = {
  theme: _propTypes2['default'].object.isRequired,
  color: _propTypes2['default'].string,
  height: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
  name: _propTypes2['default'].string,
  className: _propTypes2['default'].string
};
IllustrationController.defaultProps = {
  name: 'blank-canvas',
  className: '',
  color: ''
};
exports['default'] = (0, _reactCssThemr.themr)(_identifiers.ILLUSTRATION)(IllustrationController);
exports.Illustration = IllustrationController;